/* Carousel */
.productImageCarousel {
  max-width: 600px;
  margin: 0 auto;
}

/* Configurator */
.productListContainer {
  width: 90%;
  max-width: 1200px;
  margin: auto;
  background: #fffdf7;
  padding: 30px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.title {
  font-size: 20px;
  font-weight: 300;
  text-align: center;
  color: #505050;
}

.visuallyHiddenTitle {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.productListSelectContainer {
  display: flex;
  gap: 2vw;
  flex-wrap: wrap;
  justify-content: center;
}

.productItemContainer {
  display: flex;
  flex-direction: column;
  gap: 15px;
  cursor: pointer;
  margin-bottom: 10px;
}
.productItemContainer:hover {
  .imageContainer > .productImage {
    opacity: 0.65;
    border: 2px solid #8f8f8f;
  }
  .imageButton {
    display: block;
    z-index: 9999;
  }
}

.imageContainer {
  display: inline-block;
  position: relative;
}

.productImage {
  width: auto;
  height: 250px;
  border: 2px solid #b4b4b4;
  border-radius: 25px;
  corner-shape: superellipse(1.18);
  object-fit: cover;
  opacity: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.imageButton {
  display: none;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  animation: fadeInOut 0.3s ease-in-out;
}

.productTypeTitle {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 300;
  color: #505050;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    display: none;
  }

  50% {
    opacity: 0.5;
    display: block;
  }

  100% {
    opacity: 1;
    display: block;
  }
}

@media (max-width: 900px) {
  .productListContainer {
    padding: 0;
  }
}
